module.exports = __webpack_public_path__ + "img/034-list.bd35991b.svg";